<template>
  <div class="modal fade" :id="id" data-backdrop="static" tabindex="-1" role="dialog" aria-labelledby="staticBackdrop" aria-hidden="true">
    <div class="modal-dialog modal-md" role="document">
      <form class="form">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">{{ $t('absences.user_list_nbr_holiday') }}</h5>
            <div class="btn btn-icon btn-sm btn-active-light-primary ms-2" @click="closeModal">
                <span class="svg-icon svg-icon-1">
                  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                    <rect opacity="0.5" x="6" y="17.3137" width="16" height="2" rx="1" transform="rotate(-45 6 17.3137)"
                          fill="currentColor" />
                    <rect x="7.41422" y="6" width="16" height="2" rx="1" transform="rotate(45 7.41422 6)"
                          fill="currentColor" />
                  </svg>
                </span>
            </div>
          </div>

          <div class="modal-body">
            <div class="row">
              <table class="table align-middle table-row-bordered fs-6 gy-3 gx-4"
                    id="user_list_datatable">
                <thead>
                  <tr class="fw-bold fs-6" style="background-color: #F2F3F4;">
                    <th class="min-w-100px text-start">{{ $t('absences.user_name') }}</th>
                    <th class="min-w-100px text-end">{{ $t('absences.number_holidays') }}</th>
                  </tr>
                </thead>
                <tbody v-if="usersHolidays.length" style="background-color: #0072CE0D !important;">
                  <tr v-for="(user, index) in usersHolidays" :key="index">
                    <td class="text-start">{{user.name}}</td>
                    <td class="text-end">{{user.nbrHolidays}}</td>
                  </tr>
                </tbody> 
                <tbody v-else style="background-color: #0072CE0D !important;">
                  <tr>
                    <td colspan="2" class="text-center">
                      <Img filename="empty.png" alt="" class="mw-100 h-150px" />
                      <div class="text-gray-400 fs-4 fw-bold">{{ $t('no_data_found') }}</div>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
          <div class="modal-footer">
            <Button type="cancel" @click="closeModal" :id="id+'_cancel_btn'" btn-class="btn-sm me-3" size="7px 30px" btn-text="button.close"></Button>
          </div>
        </div>
      </form>
    </div>
  </div>

</template>

<script setup>
import {onMounted, ref, computed, defineProps, watch} from "vue";
import {useStore} from "vuex";
import Button from "@/components/Button.vue"
import Img from "@/components/Img.vue";

const props = defineProps({
    id: {
      type: String,
      required: true
    },
    societyOfficeId: {
      type: String,
      required: true
    },
})

const store = useStore()

const usersHolidays = computed(() => store.getters['absences/getUsersHolidays'])

watch(() => props.societyOfficeId, (value) => {
  if(value){
    loadUsersHolidaysCount()
  }
})

function closeModal(){
  $('#'+props.id).modal('toggle')
}

function loadUsersHolidaysCount()  {
  store.dispatch('absences/loadUsersHolidays', props.societyOfficeId) 
}

onMounted(() => {
  if(props.societyOfficeId){
    loadUsersHolidaysCount()
  }
})
</script>

<style scoped>
  tbody {
    display: block;
    max-height: 400px;
    overflow-y: auto;
  }

  thead, tbody tr {
    display: table;
    width: 100%;
    table-layout: fixed;
  }
</style>